import { useSelector } from "react-redux";
import { Button, Col, Row } from "antd";
import { useHistory } from "react-router-dom";

export const ControlesPorCargarPago = () => {
  const history = useHistory();
  const { ordenesPagoPorCargarPago } = useSelector(
    (state) => state.ordenesPagoReducer
  );

  return (
    <Row>
      <Col style={{paddingTop: 4}}>
        <span style={{ color: "#1890FF" }}>
          Total Ordenes:{" "}
          <span style={{ color: "black" }}>
            {ordenesPagoPorCargarPago.countOrdenes}
          </span>
        </span>
      </Col>
      <Col>
        <Button
          type="link"
          onClick={() => history.push("/ordenesPago/CargaPagoMasivo")}
        >
          cargar pago masivo
        </Button>
      </Col>
    </Row>
  );
};
